import { createAction } from "@reduxjs/toolkit";

export const ACTION_REVERT_ALL = 'REVERT_ALL';
export const revertAll = createAction(ACTION_REVERT_ALL);
